import { useContext } from "react";
import { ParagraphText } from "../../../Libraries";
import styles from "./styles.module.css";
import { LanguageContext } from "../../../context/LanguageContext";
import {
  BackIcon,
  BackIconNew,
  CustomerEditIcon,
  DeleteNewIcon,
} from "../../../assets/icons/icon";
import { useNavigate } from "react-router-dom";
import { sentenceCase } from "../../../constants";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const TitleAndActionBox = ({ data, children }) => {
  const {
    title,
    isTitleCase = true,
    isBack,
    onBack,
    isEdit,
    onEdit,
    onDelete,
    deleteChildren,
    id = "",
    className
  } = data;
  const [I18n, changeLanguage] = useContext(LanguageContext);
  const navigate = useNavigate();
  const canGoBack = window.history.state?.idx > 0;
  return (
    <div className={`${styles.wrapper} ${className} titleActionWrapper`}>
      <div className={`${styles.leftWrapper} titleActionLeftWrapper`}>
        {isBack && (
          <ParagraphText
            id={`${id}_back`}
            className={styles.backIcon}
            onClick={() => {
              triggerLogEvent(analytics, "title_action_back_clicked", { page_id: id });
              canGoBack ? onBack ? onBack() : navigate(-1) : navigate("/BusinessOverview");
            }}
          >
            <BackIconNew />
          </ParagraphText>
        )}

        <ParagraphText className="fontSize24 newFontColor fontWeight500 truncateTwoLine wordBreakAll" id={`${id}_title`}>
          {typeof title === "object"
            ? title
            : isTitleCase
              ? sentenceCase(I18n[title] || title)
              : I18n[title] || title}
        </ParagraphText>
        {isEdit && (
          <ParagraphText className={styles.customerEditIcon} onClick={() => {
            triggerLogEvent(analytics, "title_action_edit_clicked", { page_id: id });
            onEdit?.();
          }} id={`${id}_edit`}>
            <CustomerEditIcon />
          </ParagraphText>
        )}
        {deleteChildren
          ? deleteChildren
          : onDelete && (
            <ParagraphText className={styles.customerEditIcon} onClick={() => {
              triggerLogEvent(analytics, "title_action_delete_clicked", { page_id: id });
              onDelete();
            }} id={`${id}_delete`}>
              <DeleteNewIcon width={"16px"} height={"16px"} />
            </ParagraphText>
          )}
      </div>
      <div className={`${styles.rightWrapper} titleActionRightWrapper`}>{children}</div>
    </div>
  );
};

export default TitleAndActionBox;
